import { Typography } from '@material-ui/core';
import {
  Address,
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
  toFullAddress,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const OwnersMailingAddress: React.FC<PropertyOrderInsightsProps> = ({ property, isPdf }) => {
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.OwnerAddr,
  );
  const classes = orderInsightStyles();
  const recordedAddress = () => {
    const address = new Address();
    address.address1 = property.ownerInformation?.streetAddress;
    address.city = property.ownerInformation?.city;
    address.stateOrProvince = property.ownerInformation?.state;
    address.postalCode = property.ownerInformation?.zip9;
    return toFullAddress(address);
  };

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon
              isPdf={isPdf}
              riskSeverity={getParentSeverity(property.risks, RiskCategory.OwnerAddr)}
            />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              Owner&apos;s Mailing Address:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          <Typography variant="body1" className={clsx(classes.mb1, classes.displayFlex, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>On File:</strong>
            <span>
              {property.onFileOwnerAddressWithPartyName &&
                property.onFileOwnerAddressWithPartyName.map((x, index) => (
                  <span key={index} style={{ display: 'block' }}>
                    {x}
                  </span>
                ))}
            </span>
          </Typography>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>Recorded:</strong>
            {recordedAddress()}
          </Typography>
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
          />
        </div>
      </div>
    </div>
  );
};

export default OwnersMailingAddress;
